import templateUrl from 'servicestack/file-import/file-import-exceptions.htm';
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
//import config from 'servicestack/tags/_config'
//import labels from 'servicestack/tags/_labels'
import modals from 'webmodals/modals'

class FileImportExceptionsController {
    constructor(options, utils) {
        const $ctrl = this;
		basicController($ctrl);
		$ctrl.exceptions = options.exceptions;
		$ctrl.title = options.title || 'Import Exceptions';
		$ctrl.utils = utils;
	}

	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			customerId: 'Customer ID',
			email: "Email",
			companyName: "Company Name",
			address: "Address",
			city: "City",
			state: "State/Province",
			zip: "Zip/Postal Code",
			phone: "Phone",
			notes: "Comments/Notes",
			source: "Source",
			vendorId: "Vendor ID"
		};

		// format the data
		//$ctrl.exceptions.forEach((item) => {
		//	itemsFormatted.push({
		//		customerId: item.customerId.replace(/,/g, ''),
		//		email: item.email,
		//		companyName: item.companyName,
		//		price: item.price,
		//		openExtendedTotal: item.openExtendedTotal
		//	});
		//});

		var fileTitle = "Import Exceptions";
		$ctrl.utils.exportCSVFile(headers, $ctrl.exceptions, fileTitle);
	}

}

const FileImportExceptions = {
    open(options) {
        return modals.open(Object.assign({
			size: 'xl',
			preventAutoHeight: true,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: FileImportExceptionsController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default FileImportExceptions;